<template>
  <HomeWidgetSmall
    :actionButtonHandler="navigateToInvestigative"
    :hasError="hasError"
    :isLoading="isLoading"
    :metric="totalCount"
    :widgetType="userGroupSuggestions"
  />
</template>

<script>
import {
  ItemTypeConsts,
  ItemTypeRoutes,
} from 'client/util/Constants';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import GroupApi from 'client/api/v2/GroupApi';
import HomeWidgetConsts from 'client/HomePageV2/constants/HomeWidgetConsts';
import HomeWidgetSmall from 'client/HomePageV2/widgets/HomeWidgetSmall.vue';
import Util from 'client/util/Util';

const { userGroupSuggestions } = HomeWidgetConsts.widgetTypes;

const {
  description,
  location,
  section,
  toUrl,
  text: textEventProp,
} = eventProperties;
const {
  homePage,
} = eventLocations;

export default {
  name: 'UserGroupSuggestion',

  components: {
    HomeWidgetSmall,
  },

  viewAllRoute: ItemTypeRoutes[ItemTypeConsts.viewUserGroupSuggestions],

  data: () => ({
    hasError: false,
    isLoading: true,
    totalCount: 0,
    userGroupSuggestions,
  }),

  created() {
    this.handleTotalUserGroups();
  },

  methods: {
    handleTotalUserGroups() {
      return GroupApi.getGroupsWithSuggestions(0, 100)
        .then(({ data }) => {
          if (data.length > 0) {
            this.totalCount = data.map(resp => resp.suggestionCounts.total)
              .reduce((sugg, total) => sugg + total);
          }
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    navigateToInvestigative() {
      EventHelper.triggerWidgetClicked({
        [description]: 'User Group Suggestions - Home Page',
        [location]: homePage,
        [section]: 'Home Widgets',
        [toUrl]: this.$options.viewAllRoute,
        [textEventProp]: 'User Group Suggestions Widget',
      });
      Util.redirect(this.$options.viewAllRoute);
    },
  },
};
</script>
